module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7016/images/default-avatar.png"